module.exports = "/assets/3c77e7c36f1c8f87e8fc3ada9bed10c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KW.png
// module id = 1560
// module chunks = 0